import { render, staticRenderFns } from "./TermsList.vue?vue&type=template&id=062ce726&scoped=true&lang=html&"
import script from "./TermsList.vue?vue&type=script&lang=ts&"
export * from "./TermsList.vue?vue&type=script&lang=ts&"
import style0 from "./TermsList.vue?vue&type=style&index=0&id=062ce726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ce726",
  null
  
)

export default component.exports